import { z } from 'zod'
import { CategoryType } from '../../enums/category-type.enum'

export const categoriesQuerySchema = z.object({
  type: z.nativeEnum(CategoryType).optional(),
})

export type CategoriesQueryDto = z.infer<typeof categoriesQuerySchema>
